// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ControlFanOut } from "./control-fan-out";
import {
  ControlRouteTarget,
  ControlRouteTargetT,
  verifyControlRouteTarget,
} from "./control-route-target";
import { Control } from "../control/control";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A Control-message write routing rule.
 *
 * Rules are scoped to one channel and matched on `control`. At most one active
 * rule per (channel, control) is meaningful; when several exist, `precedence`
 * breaks the tie in ascending order.
 */
export class ControlRoute implements flatbuffers.IUnpackableObject<ControlRouteT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControlRoute {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControlRoute(bb: flatbuffers.ByteBuffer, obj?: ControlRoute): ControlRoute {
    return (obj || new ControlRoute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsControlRoute(
    bb: flatbuffers.ByteBuffer,
    obj?: ControlRoute,
  ): ControlRoute {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControlRoute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Channel this rule applies to. Only meaningful for MERGE and MIXED modes;
   * SINGLE and FAILOVER channels bypass routing entirely.
   */
  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Human-readable label (optional).
   */
  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The Control command this rule routes.
   *
   * `Control.Control` is an append-only enum whose ordinal IS its wire value
   * (see `ln2/control.fbs`). Rules persist that ordinal, so renumbering the
   * enum would silently re-point every stored rule at a different command.
   */
  control(): Control {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Control.CarCallLock;
  }

  /**
   * How many of `targets` receive the write.
   */
  fanOut(): ControlFanOut {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControlFanOut.SINGLE;
  }

  /**
   * Ascending tie-break when more than one active rule matches `control`.
   * Lower wins.
   */
  precedence(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Ordered endpoints this rule writes to.
   */
  targets(index: number, obj?: ControlRouteTarget): ControlRouteTarget | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new ControlRouteTarget()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  targetsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Disables the rule without deleting it. Inactive rules are skipped during
   * matching, so the control falls through to `Channel.control_write_mode`.
   */
  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startControlRoute(builder: flatbuffers.Builder) {
    builder.startObject(11);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, channelIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addControl(builder: flatbuffers.Builder, control: Control) {
    builder.addFieldInt16(3, control, Control.CarCallLock);
  }

  static addFanOut(builder: flatbuffers.Builder, fanOut: ControlFanOut) {
    builder.addFieldInt8(4, fanOut, ControlFanOut.SINGLE);
  }

  static addPrecedence(builder: flatbuffers.Builder, precedence: number) {
    builder.addFieldInt32(5, precedence, 0);
  }

  static addTargets(builder: flatbuffers.Builder, targetsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, targetsOffset, 0);
  }

  static createTargetsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTargetsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(7, +active, +true);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, deletedAtOffset, 0);
  }

  static endControlRoute(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // channel_id
    return offset;
  }

  unpack(): ControlRouteT {
    return new ControlRouteT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.name(),
      this.control(),
      this.fanOut(),
      this.precedence(),
      this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
        this.targets.bind(this),
        this.targetsLength(),
      ),
      this.active(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: ControlRouteT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.name = this.name();
    _o.control = this.control();
    _o.fanOut = this.fanOut();
    _o.precedence = this.precedence();
    _o.targets = this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
      this.targets.bind(this),
      this.targetsLength(),
    );
    _o.active = this.active();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): ControlRouteT {
    const t = new ControlRouteT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("control")) {
      t.control = this.control();
    }
    if (fieldSet.has("fan_out")) {
      t.fanOut = this.fanOut();
    }
    if (fieldSet.has("precedence")) {
      t.precedence = this.precedence();
    }
    if (fieldSet.has("targets")) {
      t.targets = this.bb!.createObjList<ControlRouteTarget, ControlRouteTargetT>(
        this.targets.bind(this),
        this.targetsLength(),
      );
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class ControlRouteT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public channelId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public control: Control = Control.CarCallLock,
    public fanOut: ControlFanOut = ControlFanOut.SINGLE,
    public precedence: number = 0,
    public targets: ControlRouteTargetT[] = [],
    public active: boolean = true,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.channelId === null || this.channelId === undefined) {
      throw new Error('Required field "channel_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const targets = ControlRoute.createTargetsVector(
      builder,
      builder.createObjectOffsetList(this.targets),
    );
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    ControlRoute.startControlRoute(builder);
    ControlRoute.addId(builder, id);
    ControlRoute.addChannelId(builder, channelId);
    ControlRoute.addName(builder, name);
    ControlRoute.addControl(builder, this.control);
    ControlRoute.addFanOut(builder, this.fanOut);
    ControlRoute.addPrecedence(builder, this.precedence);
    ControlRoute.addTargets(builder, targets);
    ControlRoute.addActive(builder, this.active);
    ControlRoute.addCreatedAt(builder, createdAt);
    ControlRoute.addUpdatedAt(builder, updatedAt);
    ControlRoute.addDeletedAt(builder, deletedAt);

    return ControlRoute.endControlRoute(builder);
  }

  clone(): ControlRouteT {
    const obj = new ControlRouteT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.name = this.name;
    obj.control = this.control;
    obj.fanOut = this.fanOut;
    obj.precedence = this.precedence;
    obj.targets = this.targets.map((e) => e.clone());
    obj.active = this.active;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: ControlRouteT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.name !== other.name) return false;
    if (this.control !== other.control) return false;
    if (this.fanOut !== other.fanOut) return false;
    if (this.precedence !== other.precedence) return false;
    if (this.targets.length !== other.targets.length) return false;
    for (let i = 0; i < this.targets.length; i++) {
      const a = this.targets[i];
      const b = other.targets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.active !== other.active) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyControlRoute(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "channel_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlRouteTarget);
      }
    }
    verifier.checkScalarField(tablePos, 18, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
